/** Created by azhou on 2019/3/11.*/
<template>
  <ul class="list-item">
    <li class="w-25 list-item-col">
        <span v-if="!showSortInput">{{ Itemize.sort}}</span>
        <el-input class="w-50" v-model="Itemize.sort" type="number" v-else></el-input>
    </li>
    <li class="w-50 list-item-col">{{Itemize.title}}<span v-if="Itemize.assist">({{ Itemize.assist}})</span></li>
    <li class="w-50 list-item-col">
      <div v-if="Itemize.pic.length==0" class="pic-item" @click="clickUpload(Itemize)">
        <div class="pic-item-text">待上传图片</div>
        <div class="pic-item-icon">
          <i class="iconfont icon-tianjiatupian"></i>
        </div>
      </div>
      <upload-image @fileChange="(imgs)=>RoomObj.pic = imgs" :existImgs="Itemize.pic"  :indexLength="2" :pattern="true" v-else/>  
    </li>
    <li class="w-25 list-item-col" v-if="userInfo.type == 8">{{Itemize.type | formatVar('brandroomStyle')}}</li>
    <li class="w-25 list-item-col" v-else>{{Itemize.type | formatVar('roomStyle')}}</li>
    <li class="w-25 list-item-col" >{{Itemize.window | formatVar('windowStyle')}}</li>
    <li class="w-25 list-item-col"><span class="text-info">{{Itemize.num}}</span>（间）</li>
    <li class="w-25 list-item-col"><span class="text-info">{{Itemize.area}}</span>m²</li>
    <li class="w-50 list-item-col-end">
      <span class="text-link" @click="clickUpload(Itemize)">修改图片</span>
      <span class="text-link ml-2" @click="$emit('editItem')">编辑信息</span>
      <span class="text-link ml-2" @click="$emit('clone')">克隆</span>
      <span class="ml-2 text-link" @click="$emit('deleteItem')">删除</span>
    </li>
  </ul>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'Itemize',
    props: {
      Itemize:{},
      showSortInput:Boolean
    },
    computed: {
      ...mapGetters(['userInfo']),
    },
    methods: {
      //修改图片
      clickUpload(item){
        this.$emit('uploadPic',item)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .pic-item{
    width: 70px;
    height: 70px;
    padding-left: 20px;
  }
  .pic-item-text{
    font-size: 10px;

  }
  .pic-item-icon{
    width: 50px;
    height: 50px;
    border: 1px #eee dashed ;
    margin: 0 auto;
    border-radius: 4px;
    margin-top:4px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
  }
  .icon-tianjiatupian{
    color: #999;
  }
</style>
